import { render, staticRenderFns } from "./MsisdnField.vue?vue&type=template&id=bf46164e&"
import script from "./MsisdnField.vue?vue&type=script&lang=js&"
export * from "./MsisdnField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports